<template>
  <div class="container">
    <!-- <div class="total-box">
      <div class="total-setting">
        <div class="title">Total Alert Settings</div>
        <div class="title-head">
          <p>Max Loss Per Day</p>
          <p>{{totalForm.maxLossPerDay}}</p>
        </div>
        <div class="title-head">
          <p>Max Loss Per Match</p>
          <p>{{totalForm.maxLossPerMatch}}</p>
        </div>
        <div class="title-head">
          <p>Warning Percentage</p>
          <p>{{totalForm.warningPercentage}}%</p>
        </div>
        <div class="title-head">
          <p>Warning Step</p>
          <p>{{totalForm.warningStep}}%</p>
        </div>
      </div>
      <div class="btn-wrapper">
        <el-button class="add-new-btn" @click="handleEdit()">
          <i style="font-size: 14px;" class="iconfont iconProperty1bi"></i> Edit
        </el-button>
      </div>
    </div>-->
    <div class="level-template">
      <div class="btn-wrapper">
        <el-button class="add-new-btn" @click="handleViewAdd(1)">
          <i class="iconfont iconProperty1tianjia"></i> Add
        </el-button>
      </div>
      <div class="risk-table risklist-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          :indent="0"
          v-loading="loading"
          header-row-class-name="table-header-row"
          border
          row-key="rowId"
          :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="ID" prop="id" min-width="50px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{row.id}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel Template" min-width="130px" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{row.name}}</span>
                <span class="default" v-if="row.id == 1">Default 100%</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Warning %" prop="warning" min-width="101px" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.warning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Loss Per Day" min-width="165px" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{row.warningLossPerDay}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Warning Loss Per Match" min-width="190px" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{row.warningLossPerMatch}}</div>
            </template>
          </el-table-column>-->
          <el-table-column label="Stake Factor" prop="levelId" min-width="150px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{fetchLevel(row.levelId,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Stake Factor(New User)" min-width="160px" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{fetchLevel(row.newUserLevelId,2)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Minimum Stake Factor" min-width="150px" align="left">
            <template v-slot="{row}">
              <div style="text-align: center;">{{row.minStakeFactor}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Remark" prop="remark" min-width="150px" align="left"></el-table-column>
          <el-table-column label="Operation" min-width="340px" align="center">
            <template v-slot="{row}">
              <div>
                <el-button class="table-inner-btn" @click="handleViewAdd(2,row)">Modify</el-button>
                <el-button class="table-inner-btn" @click="handleViewAdd(4,row)">History</el-button>
                <el-button
                  class="table-inner-btn"
                  :disabled="row.id == 1"
                  @click="handleViewAdd(3,row)"
                >Delete</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>-->
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <div>
        <el-form :model="totalForm" label-width="150px">
          <el-form-item label="Max Loss Per Day">
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="totalForm.maxLossPerDay"
            ></el-input>
          </el-form-item>
          <el-form-item label="Max Loss Per Match">
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="totalForm.maxLossPerMatch"
            ></el-input>
          </el-form-item>
          <el-form-item label="Warning Percentage">
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="totalForm.warningPercentage"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="Warning Step">
            <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="totalForm.warningStep">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleModify(totalForm)">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
    <dia ref="diaListDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="queryForm" label-width="160px">
          <el-form-item label="Channel Template Name">
            <el-input v-model="queryForm.name"></el-input>
          </el-form-item>
          <!-- <el-form-item label="Warning %">
            <el-input v-model="queryForm.warning">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>-->
          <el-form-item label="Stake Factor">
            <el-select
              v-model="queryForm.levelId"
              filterable
              clearable
              placeholder="Select User Limit"
            >
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Stake Factor(New User)">
            <el-select
              v-model="queryForm.newUserLevelId"
              filterable
              clearable
              placeholder="Select Stake Factor"
            >
              <el-option :value="null" label="Blank"></el-option>
              <el-option
                v-for="item in levelList"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Minimum Stake Factor">
            <el-input v-model="queryForm.minStakeFactor" @keypress.native="handleKeyPress"></el-input>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="queryForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleListModify()">Confirm</el-button>
          <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div class="dialog-footer table-search-part" v-if="num == 3">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
      </div>
      <!-- history4 -->
      <div v-if="num == 4">
        <el-table
          ref="table"
          :data="historyList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Time" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{formatUtc(row.updateTime)}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Channel Template Name" align="left">
            <template v-slot="{row}">
              <div class="level-box">
                <span>{{row.name}}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Warning %" prop="warning" align="center">
            <template v-slot="{row}">
              <div style="text-align: center;">{{+(row.warning * 100).toFixed(4)}}%</div>
            </template>
          </el-table-column>-->
          <el-table-column label="Stake Factor" prop="levelId" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{fetchLevel(row.levelId,1)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Stake Factor(New User)" prop="newUserLevelId" align="left">
            <template v-slot="{row}">
              <div style="text-align: left;">{{fetchLevel(row.newUserLevelId,2)}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Minimum Stake Factor" prop="minStakeFactor" align="left"></el-table-column>
          <el-table-column label="Remark" prop="remark" align="left"></el-table-column>
          <el-table-column label="Modifier" prop="modifier" align="left"></el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryHistoryData.current"
            :page-size="queryHistoryData.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>
<script>
import Empty from "@/components/empty/index";
import dia from "@/components/dialog/index";
import {
  getChannelDetailsList,
  getTemplateList,
  getTemplateHistory,
  getTemplateUpdate,
  getTemplateDelete,
  updateBatchPublishGlobalSetting,
  publish
} from "@/api/channel";
import { getRiskLevel } from "@/api/member";
export default {
  components: {
    Empty,
    dia
  },
  data() {
    return {
      list: [],
      status: false,
      levelList: [],
      total: 0,
      loading: false,
      loadingItem: false,
      historyList: [],
      totalAert: 0,
      num: "",
      templateId: "",
      totalForm: {
        maxLossPerDay: "",
        maxLossPerMatch: "",
        warningPercentage: "",
        warningStep: ""
      },
      form: [
        { value: "", code: "", id: "" },
        { value: "", code: "", id: "" },
        { value: "", code: "", id: "" },
        { value: "", code: "", id: "" }
      ],
      data: [],
      queryForm: {
        name: "",
        warning: "",
        levelId: -1,
        remark: "",
        newUserLevelId: null,
        minStakeFactor: 1,
        id: "",
        createTime: ""
      },
      queryData: {
        pageNum: 1,
        pageSize: 100
      },
      queryHistoryData: {
        templateId: "",
        current: 1,
        size: 50
      },
      queryTotalData: {
        pageNum: 1,
        pageSize: 500
      },
      tableHeight: window.innerHeight
    };
  },
  mounted() {
    this.getRiskLevel();
    //this.getTotalSetting();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  methods: {
    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      let dataList = this.getArray(data);
      this.levelList = dataList;
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    filterData(data) {
      let res = data.filter(item => {
        let strArr = item.name.split("%");
        if (strArr.length > 1 && Number(strArr[0]) > 100) {
          return false;
        }
        return true;
      });
      return res;
    },
    async getList() {
      this.loading = true;
      const res = await getTemplateList(this.queryData);
      this.list = res.data || [];
      this.total = Number(res.total);
      this.loading = false;
    },
    async getTotalSetting() {
      const res = await getChannelDetailsList(this.queryTotalData);
      const data = res.data.globalSettingDTOList || [];
      if (data.length > 0) {
        data.map(item => {
          if (item.code == "MAX_LOSS_PER_DAY") {
            this.totalForm.maxLossPerDay = item.value;
            this.form[0].value = item.value;
            this.form[0].code = item.code;
            this.form[0].id = item.id;
          }
          if (item.code == "MAX_LOSS_PER_MATCH") {
            this.totalForm.maxLossPerMatch = item.value;
            this.form[1].value = item.value;
            this.form[1].code = item.code;
            this.form[1].id = item.id;
          }
          if (item.code == "WARNING_PERCENTAGE") {
            this.totalForm.warningPercentage = +(item.value * 100).toFixed(4);
            this.form[2].value = item.value;
            this.form[2].code = item.code;
            this.form[2].id = item.id;
          }
          if (item.code == "WARNING_STEP") {
            this.totalForm.warningStep = +(item.value * 100).toFixed(4);
            this.form[3].value = item.value;
            this.form[3].code = item.code;
            this.form[3].id = item.id;
          }
        });
      }
    },
    fetchLevel(val, num) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
        if (num === 1) {
          if (!val) {
            name = "Default 100%";
          }
        }
      });
      return name;
    },
    handleEdit() {
      // 修改
      this.title = "Edit";
      this.$refs["dialogDom"].isShowDia(this.title, true, "600px");
    },
    // 修改
    async handleModify(data) {
      if (
        data.maxLossPerDay &&
        data.maxLossPerMatch &&
        data.warningPercentage &&
        data.warningStep
      ) {
        this.form[0].value = data.maxLossPerDay;
        this.form[1].value = data.maxLossPerMatch;
        this.form[2].value = data.warningPercentage / 100;
        this.form[3].value = data.warningStep / 100;
        const res = await updateBatchPublishGlobalSetting(this.form);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
        }
        this.getList();
        this.Close();
      } else {
        this.$message({
          message: "Must Input Total Alert Settings",
          type: "warning"
        });
        this.Close();
      }
    },
    async publishFun() {
      const pub = await publish({});
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "600px");
      this.getTotalSetting();
    },
    CloseHistory() {
      this.$refs["diaListDom"].isShowDia(this.title, false, "1300px");
    },
    handleKeyPress(event) {
      const keyCode = event.keyCode || event.which;
      const keyChar = String.fromCharCode(keyCode);
      const inputValue = event.target.value + keyChar;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 46) {
        event.preventDefault();
        return;
      }
      const parsedValue = parseInt(inputValue);
      if (parsedValue < 1 || parsedValue > 100) {
        event.preventDefault();
        return;
      }
      if (/[^0-9]/.test(inputValue)) {
        event.preventDefault();
        return;
      }
    },
    handleViewAdd(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add Template";
        this.queryForm.name = "";
        this.queryForm.warning = "";
        this.queryForm.levelId = -1;
        this.queryForm.newUserLevelId = null;
        this.queryForm.remark = "";
        this.queryForm.id = "";
        this.queryForm.minStakeFactor = 1;
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      } else if (num == 2) {
        // 修改
        let levelId = "";
        if (!data.levelId) {
          levelId = -1;
        } else {
          levelId = data.levelId;
        }
        this.title = "Modify Template";
        this.queryForm.name = data.name;
        this.queryForm.warning = +(data.warning * 100).toFixed(4);
        this.queryForm.levelId = levelId;
        this.queryForm.newUserLevelId = data.newUserLevelId;
        this.queryForm.minStakeFactor = data.minStakeFactor;
        this.queryForm.remark = data.remark;
        this.queryForm.id = data.id;
        this.queryForm.createTime = data.createTime;
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      } else if (num == 4) {
        this.queryHistoryData.current = 1;
        this.queryHistoryData.size = 50;
        this.title = "Channel Template History";
        this.queryHistoryData.templateId = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "1300px");
        this.getHistoryList();
      } else {
        // 删除
        this.title = "Delete Template?";
        this.templateId = data.id;
        this.$refs["diaListDom"].isShowDia(this.title, true, "600px");
      }
    },
    async getHistoryList() {
      this.loadingItem = true;
      try {
        const res = await getTemplateHistory(this.queryHistoryData);
        const data = res.data || {};
        this.historyList = data.records || [];
        this.totalAert = Number(data.total);
        this.loadingItem = false;
      } catch (error) {
        this.historyList = [];
        this.loadingItem = false;
      }
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 分页
    changeAlertPage(e) {
      this.queryHistoryData.current = e;
      this.getHistoryList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryHistoryData.size = e;
      this.queryHistoryData.current = 1;
      this.getHistoryList();
    },
    async handleListModify(data) {
      let warning = "";
      if (this.queryForm.warning) {
        warning = this.queryForm.warning / 100;
      }
      let param = { ...this.queryForm };
      try {
        const res = await getTemplateUpdate(param);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          this.publishFun();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    listClose() {
      this.$refs["diaListDom"].isShowDia(this.title, false, "600px");
    },
    // 删除
    async Delete() {
      const res = await getTemplateDelete({ templateId: this.templateId });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.listClose();
      }
    },
    // 分页
    changePage(e) {
      this.queryData.pageNum = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.pageSize = e;
      this.queryData.pageNum = 1;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 30px;
  line-height: 30px;
  .total-box {
    display: flex;
    align-items: flex-start;
    margin: 10px 0;
    .total-setting {
      display: flex;
      align-items: center;
      border: 1px solid #f5f5f5;
      border-radius: 10px;
      width: 1200px;
      height: 67px;
      margin-right: 20px;
      .title {
        width: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        font-size: 16px;
        font-weight: 700;
        height: 65px;
        border-right: 1px solid #f5f5f5;
      }
      .title-head {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 65px;
        border-right: 1px solid #f5f5f5;
        &:last-child {
          border: none;
        }
        p {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 33px;
          color: #666;
          font-size: 12px;
          &:first-child {
            border-bottom: 1px solid #f5f5f5;
            color: #333 !important;
          }
        }
      }
    }
    .edit-btn {
      background: #f8f8f8;
      border: 1px solid #f5f5f5;
    }
  }
  .level-template {
    .btn-wrapper {
      margin-bottom: 15px;
      text-align: right;
      .add-new-btn {
        background: #00a791 !important;
        color: #fff !important;
      }
    }
    .level-box {
      display: flex;
      align-items: left;
      flex-direction: column;
      .default {
        background: #e1554f;
        padding: 4px 6px 3px;
        border-radius: 15px;
        color: #fff;
        width: 90px;
        text-align: center;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
